/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: 'Puhelinsoitto 1',
  [RINGS_TYPE.Phone_Ring2]: 'Puhelinsoitto 2',
  [RINGS_TYPE.Acoustic_Dreams]: 'Akustiset unelmat',
  [RINGS_TYPE.Air_Raid]: 'Ilmahälytys',
  [RINGS_TYPE.Allusive]: 'Vihjaileva',
  [RINGS_TYPE.Attention]: 'Huomio',
  [RINGS_TYPE.Blub_Blub]: 'Pulpahdus',
  [RINGS_TYPE.Buzzy]: 'Surina',
  [RINGS_TYPE.Channel_Open]: 'Kanava auki',
  [RINGS_TYPE.Contemplation]: 'Suunnittelu',
  [RINGS_TYPE.Crystal_Ball]: 'Kristallipallo',
  [RINGS_TYPE.Disco]: 'Disko',
  [RINGS_TYPE.Door_Bell]: 'Ovikello',
  [RINGS_TYPE.Fairy]: 'Keijukainen',
  [RINGS_TYPE.Fast_Bells]: 'Nopeat kellot',
  [RINGS_TYPE.High_Gong]: 'Korkea gongi',
  [RINGS_TYPE.Immersion]: 'Uppoutuminen',
  [RINGS_TYPE.Indeed]: 'Niinpä',
  [RINGS_TYPE.Lazy_Day]: 'Laiska päivä',
  [RINGS_TYPE.Neural_Funk]: 'Neurofunk',
  [RINGS_TYPE.Nice]: 'Kiva',
  [RINGS_TYPE.Ring]: 'Soitto',
  [RINGS_TYPE.Ringing_Bells]: 'Soivat kellot',
  [RINGS_TYPE.Simple]: 'Yksinkertainen',
  [RINGS_TYPE.Soothing]: 'Rauhoittava',
  [RINGS_TYPE.Sunshine]: 'Auringonpaiste',
  [RINGS_TYPE.Off]: 'Pois päältä',
  add: 'Lisää',
  delete: 'Poista',
  play: 'Toista',
  cancel: 'Peruuta',
  confirmToDelete: 'Poistetaanko {name}?',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
